import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import style from './style'

class Application extends PureComponent {

    static displayName = '[page] application';

    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    };

    render() {
        return (
            <div className={style.application}>
                {this.props.children}
            </div>
        )
    }

}

export { Application as default };



// WEBPACK FOOTER //
// ./src/pages/application/index.js